<template>
  <div class="pa-0" style="position: relative">
    <v-row class="s-btn-filter">
      <v-col cols="12" class="d-flex">
        <v-menu
          :internal-activator="true"
          v-model="openMenu"
          content-class="menu__customer--filter no-contain overflow-visible"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin-right: 10px"
              class="mb-2"
              color="primary"
              dark
              v-on="on"
            >
              <span>Lọc theo điều kiện</span>
              <v-icon style="margin-left: 10px; margin-right: -20px"
                >mdi-chevron-down</v-icon
              >
            </v-btn>
          </template>
          <v-card
            class="mx-auto overflow-visible"
            width="900px"
            style="margin-top: 0px; margin-bottom: 0px"
            outlined
          >
            <div class="px-6 py-4">
              <div class="d-flex justify-space-between">
                <h3 style="align-self: center;">Tìm kiếm nâng cao</h3>
                <v-btn
                  @click="openMenu = false"
                  class="close-btn"
                  icon
                  color="primary"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <div>
                <v-text-field
                  placeholder="Nhập mã đơn hàng"
                  v-model="filterForm.orderCode"
                  label="Mã đơn hàng"
                  clearable
                />
              </div>
              <div class="d-flex justify-space-between">
                <div style="width: 49%">
                  <v-text-field
                    placeholder="Nhập mã phiếu thu"
                    v-model="filterForm.receiptCode"
                    label="Mã phiếu thu"
                    clearable
                  />
                </div>
                <div style="width: 49%">
                  <common-range-picker
                    :clearable="true"
                    :aLight="'center'"
                    label="Ngày tạo phiếu thu"
                    v-model="filterForm.createdAt"
                  />
                </div>
              </div>
              <div class="d-flex justify-space-between">
                <div style="width: 49%">
                  <v-autocomplete
                    v-model="filterForm.paymentType"
                    :items="paymentTypes"
                    item-text="name"
                    item-value="id"
                    label="Phương thức thanh toán"
                    placeholder="Chọn phương thức thanh toán"
                    clearable
                  />
                </div>
                <div style="width: 49%">
                  <v-autocomplete
                    v-model="filterForm.statusIds"
                    :items="statusReceipts"
                    item-text="name"
                    item-value="id"
                    label="Trạng thái phiếu thu"
                    placeholder="Chọn trang thái phiếu thu"
                    clearable
                    multiple
                  />
                </div>
              </div>
              <div>
                  <common-select-user
                    class="btn-style-all"
                    v-model="filterForm.createdBy"
                    :items="users"
                    color="primary"
                    item-text="fullName"
                    item-value="id"
                    placeholder="Chọn người tạo phiếu thu"
                    label="Người tạo phiếu thu"
                    multiple
                    clearable
                  />
                </div>
            </div>

            <div class="d-flex text-center mb-4 justify-center">
              <v-btn
                class="primary mx-0"
                @click="searchOrder"
              >
                <v-icon>mdi-dropdown</v-icon>Tìm kiếm
              </v-btn>
            </div>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine');
const OrderRepository = RepositoryFactory.get('order');
export default {
  props: {
    filterForm: {
      default: () => ({}),
    },
  },
  data() {
    return {
      users: [],
      openMenu: false,
      statusReceipts: [
        { id: "init", name: "Chờ xử lý" },
        { id: "in_progress", name: "Chờ thanh toán" },
        { id: "final_success", name: "Thành công" },
        { id: "final_return", name: "Hoàn" },
        { id: "final_cancel", name: "Hủy" },
        { id: "final_failed", name: "Thất bại" },
      ],
      paymentTypes: [
        {id: 'COD', name: 'COD'},
        {id: 'BANK', name: 'BANK'},
        {id: 'MONEY_RECEIPT', name: 'Biên nhận'}
      ],
      itemsExport: [
          { title: 'Đối soát', code: 'DOISOAT' },
          { title: 'Kế toán', code: 'KETOAN' },
          { title: 'Kế toán hoá đơn', code: 'KETOANHOADON' },
      ],
    };
  },
  async created() {
    await this.getUsers();
  },
  methods: {
    async getUsers() {
      const res = await OrganizationMachineRepository.listUserContactAdvise({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
      });

      if (res.success) {
        let listUsers = _.get(res, "data", []);
        const groupUsers = [];
        const listMinistries = [];
        listUsers.forEach((ministry) => {
          if (ministry.name != "Inactive") {
            listMinistries.push({
              id: ministry.id,
              name: ministry.name,
            });
          }

          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: _.get(ministry, "name"),
              name: _.get(ministry, "name"),
              ministryId: ministry.id,
            });
            users.forEach((user) => {
              groupUsers.push({
                fullName: _.get(user, "fullName"),
                group: _.get(ministry, "name"),
                id: user.id,
                avatar: _.get(user, "avatar.filePath"),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = _.cloneDeep(groupUsers);
      } else {
        this.$swal({
          title: "Lỗi!",
          text: _.get(res, "message", ""),
        });
      }
    },
    searchOrder() {
      this.openMenu = false;
      this.$emit("searchOrder", this.filterForm);
    },
  },
};
</script>

<style>
</style>
<style scoped>
/deep/.m--contact-assignedAt .daterangepicker.openscenter {
  left: calc(50% + 100px) !important;
}
/deep/.m--contact-appointmentAt .daterangepicker.openscenter {
  left: 0 !important;
}
.group-btn-search {
  position: absolute;
  top: 8px;
  right: -15px;
  max-width: 130px;
}
.group-btn-search .search-contact--dropdown {
  position: absolute;
  right: 0;
  z-index: 1;
}
.menu__customer--filter {
  top: calc(30% - 45px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.s-btn-filter {
  position: absolute;
  z-index: 1;
  right: 0;
}
/deep/.v-subheader.theme--light {
  width: 100%;
  background: rgb(206, 150, 104);
}
</style>
